import { useState } from 'react'

export const useTable = (data, itemsPerPage, searchTerm) => {
    const [currentPage, setCurrentPage] = useState(1);
    // Filtrage des données en fonction de la recherche
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )

    );
    
    //  Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  
  // Changement de page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return {
    currentItems, // Données actuelles à afficher
    filteredData, // Données filtrées (pour la pagination)
    currentPage, // Page actuelle
    paginate, // Fonction pour changer de page
  };
}